import { Select } from "@portal/BaseComponents/Select/AntSelect";
import { DisputeStatus } from "@portal/types/entities/dispute";
import { styled } from "@stitches/react";

export const StyledDisputeStatus = styled(Select<DisputeStatus>, {
  ".ant-select-selection-item": {
    color: "var(--statusTextColor)",
  },
  "&.ant-select:not(.ant-select-customize-input) .ant-select-selector": {
    border: " 1px solid var(--statusBorderColor) !important",
  },

  ".ant-select-arrow": {
    color: " var(--gray-9)",
  },
});
